```vue file="UploadMenu.vue" type="code" project="UploadMenu" isAttachmentQuickEdit
[v0-no-op-code-block-prefix]<template>
    <div class="upload-menu-container">
      <div class="upload-menu-wrapper">
        <div class="upload-menu">
          <div 
            v-for="(item, index) in menuItems" 
            :key="index"
            class="upload-menu-item"
            :class="{ 'active': selectedItem === `page${index+1}` }"
            @click="openItemChoosed(index+1)"
          >
            <v-icon 
              class="menu-icon" :dark="selectedItem !== `page${index+1}`"
              :class="{ 'active-icon': selectedItem === `page${index+1}` }"
            >
              {{ item.icon }}
            </v-icon>
            <span class="menu-text">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      routerSelected: String
    },
    data: () => ({
      selectedItem: "page1",
      menuItems: [
        { 
          title: "ניהול הקלטת תפריט", 
          icon: "mdi-playlist-music" 
        },
        { 
          title: "ניהול שלוחת הודעות", 
          icon: "mdi-message-text" 
        },
        { 
          title: "קבצים שנמחקו", 
          icon: "mdi-delete" 
        },
        { 
          title: "קבצים זמניים", 
          icon: "mdi-clock-outline" 
        }
      ]
    }),
    methods: {
      openItemChoosed(itemNum) {
        if (this.$route.params.page !== `page${itemNum}`) {
          this.$router.replace({ 
            name: `upload`, 
            params: { page: `page${itemNum}` } 
          });
          this.selectedItem = `page${itemNum}`;
          this.$emit('barUploadItemSelected', "page" + itemNum);
        }
      }
    },
    created() {
      this.selectedItem = this.routerSelected;
    }
  }
  </script>
  
  <style scoped>
  .upload-menu-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 30px;
  }
  
  .upload-menu-wrapper {
    width: 95%;
    max-width: 1200px;
  }
  
  .upload-menu {
    display: flex;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    height: 57px;
    transition: all 0.3s ease;
  }
  
  .upload-menu-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    height: 100%;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1;
    position: relative;
    border-left: 1px solid rgba(0, 0, 0, 0.05);
  }
  
  .upload-menu-item:last-child {
    border-left: none;
  }
  
  .upload-menu-item:hover {
    background-color: rgba(13, 44, 109, 0.05);
  }
  
  .upload-menu-item.active {
    background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
    box-shadow: 0 2px 8px rgba(255, 185, 26, 0.2);
  }
  
  .menu-icon {
    margin-left: 10px;
    color: #0d2c6d;
    transition: all 0.3s ease;
  }
  
  .active-icon {
    color: white;
    transform: scale(1.1);
  }
  
  .menu-text {
    font-size: 16px;
    font-weight: 600;
    color: #0d2c6d;
    transition: all 0.3s ease;
    white-space: nowrap;
  }
  
  .active .menu-text {
    color: white;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .upload-menu {
      flex-wrap: wrap;
      height: auto;
    }
    
    .upload-menu-item {
      flex: 1 0 50%;
      padding: 15px 10px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
    
    .upload-menu-item:nth-child(odd) {
      border-left: none;
    }
    
    .upload-menu-item:nth-last-child(1),
    .upload-menu-item:nth-last-child(2) {
      border-bottom: none;
    }
    
    .menu-text {
      font-size: 14px;
    }
  }
  
  @media (max-width: 480px) {
    .upload-menu-item {
      flex: 1 0 100%;
      border-left: none;
    }
    
    .upload-menu-item:nth-last-child(1) {
      border-bottom: none;
    }
  }
  </style>